import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import InitialSyncSejam from './InitialSyncSejam';
import RequestSejamSendOtp from './RequestSejamSendOtp';
import RequestSejamVerifyOtp from './RequestSejamVerifyOtp';
import DoneSyncSejam from './DoneSyncSejam';
import { Modal } from '@/ui/kit/components/modal';
import { useSejamSendOtp } from '@/api/hooks/sejam/auth/useSejamSendOtp';
import { useSejamVerifyOtp } from '@/api/hooks/sejam/auth/useSejamVerifyOtp';
import { SejamSendOtp } from '@/api/hooks/sejam/auth/types';
import NoSejamInfo from '@/containers/auth/components/NoSejamInfo';
import { get2MinuetsLaterInTimestamp } from '@/utils/function';
type Props = {
  open: boolean;
  onClose: () => void;
  initial?: boolean;
};
enum Steps {
  STEP_INITIAL,
  STEP_SEND_OTP,
  STEP_NO_SEJAM,
  STEP_VERIFY_OTP,
  STEP_DONE,
}
const SejamSyncModal = (props: Props) => {
  const queryClient = useQueryClient();
  const [sejamSyncStep, setSejamSyncStep] = useState(props.initial ? Steps.STEP_INITIAL : Steps.STEP_SEND_OTP);
  const startSejamSyncHandler = () => {
    setSejamSyncStep(Steps.STEP_SEND_OTP);
  };
  const sendSejamOtpSuccessHandler = () => {
    setSejamSyncStep(Steps.STEP_VERIFY_OTP);
  };
  const sendSejamOtpErrorHandler = (error: SejamSendOtp['Error']) => {
    if (error.error_code === 'user_not_exists') {
      setSejamSyncStep(Steps.STEP_NO_SEJAM);
    }
  };
  const verifySejamOtpSuccessHandler = () => {
    queryClient.invalidateQueries({
      queryKey: ['profile']
    });
    setSejamSyncStep(Steps.STEP_DONE);
  };
  const {
    mutate: mutateSejamSendOtp,
    isPending: sendOtpPending
  } = useSejamSendOtp({
    onSuccess: sendSejamOtpSuccessHandler,
    onError: sendSejamOtpErrorHandler
  });
  const {
    mutate: mutateSejamVerifyOtp,
    isPending: verifyOtpPending,
    isSuccess: verifyOtpIsSuccess
  } = useSejamVerifyOtp({
    onSuccess: verifySejamOtpSuccessHandler
  });
  const requestSendSejamOtpHandler = () => {
    mutateSejamSendOtp();
  };
  const requestSejamVerifyOtpHandler = (code: string) => {
    mutateSejamVerifyOtp({
      code
    });
  };
  const onCloseHandler = () => {
    setSejamSyncStep(props.initial ? Steps.STEP_INITIAL : Steps.STEP_SEND_OTP);
    props.onClose();
  };
  return <Modal dialogProps={{
    maxWidth: 'xs'
  }} onClose={onCloseHandler} open={props.open} title={Steps.STEP_INITIAL === sejamSyncStep ? 'تکمیل پروفایل' : 'همگام‌سازی سجام'} data-sentry-element="Modal" data-sentry-component="SejamSyncModal" data-sentry-source-file="index.tsx">
      {sejamSyncStep === Steps.STEP_INITIAL && <InitialSyncSejam startSync={startSejamSyncHandler} />}

      {sejamSyncStep === Steps.STEP_SEND_OTP && <RequestSejamSendOtp sendOtp={requestSendSejamOtpHandler} loading={sendOtpPending} />}
      {sejamSyncStep === Steps.STEP_VERIFY_OTP && <RequestSejamVerifyOtp sendOtp={requestSendSejamOtpHandler} otpTimeout={get2MinuetsLaterInTimestamp().toString()} verifyOtp={requestSejamVerifyOtpHandler} verifyOtpLoading={verifyOtpPending} sendOtpLoading={sendOtpPending} isSuccess={verifyOtpIsSuccess} />}
      {sejamSyncStep === Steps.STEP_DONE && <DoneSyncSejam iNoticeHandler={props.onClose} />}
      {sejamSyncStep === Steps.STEP_NO_SEJAM && <NoSejamInfo back={props.onClose} message='وضعیت حساب سجام شما نامشخص است. لطفا جهت ثبت‌نام یا تکمیل احراز  هویت به سامانه سجام مراجعه کنید.' />}
    </Modal>;
};
export default SejamSyncModal;